import {
    getMeterReading,
    listMeterReadings
} from './queries';
import {
    createMeterReading,
    deleteMeterReading,
    updateMeterReading,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {MeterReading} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


export type ListMeterReadings = {
    listMeterReadings: { items: MeterReading[], nextToken: string }
}

export type GetMeterReading = {
    getMeterReading: MeterReading
}

export type CreateMeterReading = {
    createMeterReading: MeterReading
}

export type UpdateMeterReading = {
    updateMeterReading: MeterReading
}

export type DeleteMeterReading = {
    deleteMeterReading: string
}


const client = billingApiClient;


export const fetchRecords = async (query: ListRecordsQuery) => {
    const response = await client.graphql<GraphQLQuery<ListMeterReadings>>({
                                                                                 query: listMeterReadings,
                                                                                 variables: {
                                                                                     ...query
                                                                                 },
                                                                             });
    return {
        items: response.data?.listMeterReadings.items,
        nextToken: response.data?.listMeterReadings.nextToken
    }
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetMeterReading>>({
                                                                               query: getMeterReading,
                                                                               variables: {id: id},
                                                                           });
    return response.data?.getMeterReading;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateMeterReading>>({
                                                                                  query: createMeterReading,
                                                                                  variables: {input: payload},
                                                                              });
    console.debug('in the service response', response);
    return response.data?.createMeterReading;
};

export const update = async (id: string, record: MeterReading) => {

    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateMeterReading>>({
                                                                                  query: (updateMeterReading),
                                                                                  variables: {input: record},
                                                                              });
    return response.data?.updateMeterReading;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteMeterReading>>({
                                                                                  query: (deleteMeterReading),
                                                                                  variables: {input: {id: id}},

                                                                              });
    return response.data?.deleteMeterReading;
};
